import { ShowIf, ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { useCustomPaymentAddressState, useCustomPaymentIsPropertyInArizona } from '../../../fields/CustomPaymentFields';

interface PropertyInArizonaProps {
    customPaymentId: string;
}

export const PropertyInArizona: React.FC<PropertyInArizonaProps> = ({ customPaymentId }) => {
    const label = 'Is the Property in Arizona?';
    const [state] = useCustomPaymentAddressState(customPaymentId);
    const [isPropertyInArizona, set_isPropertyInArizona] = useCustomPaymentIsPropertyInArizona(customPaymentId);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_isPropertyInArizona(true);
                return;
            case 'no':
                set_isPropertyInArizona(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            <ShowIf showIf={state == 'AZ'}>
                <YesNoToggleButton
                    id='toggleButtonIsPropertyInArizona'
                    value={isPropertyInArizona}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={true}
                    requiredMessage='This field is required.'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            </ShowIf>
        </>
    );
};
